import React, { useEffect, useRef, useState } from "react"
import SVG from "react-inlinesvg"
import * as styles from "./SupplierSearchFilterList.module.scss"
import SupplierSearchFilterListOption from "./SupplierSearchFilterListOption"
import { eventGtag } from "@lib/gtag"
import useMediaQuery from "@lib/useMediaQuery"
import Button from "@components/objects/Button/Button"
import expandArrowDown from "@images/icons/expandArrowDown.svg"

const SupplierSearchFilterList = ({
  name,
  title,
  filter,
  placeholder,
  placeholderIcon,
  handleFilterChange,
  options,
  className,
  isMulti = false,
}) => {
  //Resize control
  const isMobile = useMediaQuery(767)

  const [isClosed, setIsClosed] = useState(isMobile)

  useEffect(() => {
    if (isMobile) {
      setIsClosed(true)
    }
  }, [isMobile])

  const handleChange = (event) => {
    event.preventDefault()
    const value = event.target.value
    const label = event.target.dataset.label
    const checked = event.target.checked
    let newFilter = filter ? [...filter] : []
    if (isMulti) {
      if (checked) {
        newFilter.push(value)
      } else {
        newFilter = newFilter.filter((el) => el !== value)
        newFilter = newFilter.legnth ? newFilter : null
      }
    } else {
      if (checked) {
        newFilter = [value]
        eventGtag({
          action: "Selected",
          params: {
            event_category: name === "services" ? "Service" : name,
            event_label: label,
            value: value,
          },
        })
      } else {
        newFilter = null
      }
    }
    if (isMobile) {
      setIsClosed(true)
    }
    handleFilterChange(name, newFilter)
    window.scroll({ top: 0, behavior: "smooth" })
  }

  const hasGroups = options?.[0]?.options?.length

  const allOptions = hasGroups ? options.map((group) => group.options).flat() : options

  const selected = filter?.map((el) => allOptions.find((option) => option.value === el))

  return (
    <div className={`${styles.SupplierSearchFilterList} ${styles[name]} ${className} ${isClosed ? styles.closed : ""}`}>
      <div className={styles.heading} onClick={() => setIsClosed(!isClosed)}>
        {isMobile ? (
          <div className={`${styles.selected} ${selected?.length ? styles.active : ""}`}>
            {placeholderIcon && (
              <SVG
                src={selected?.[0]?.iconActive?.url ? selected[0].iconActive.url : placeholderIcon}
                width={20}
                height="auto"
                preProcessor={(code) => code.replace(/style=".*?"/g, 'style=""')}
              />
            )}
            <span>{selected?.length ? selected.map((el) => el.label).join(", ") : placeholder}</span>
          </div>
        ) : (
          <h3 className={styles.title}>{title}</h3>
        )}
        <Button className={styles.expandArrow} design="image" image={expandArrowDown} />
      </div>
      <div className={styles.filters}>
        {hasGroups ? (
          options.map((group) => (
            <div key={group.id} className={styles.group}>
              <h4 className={styles.title}>{group.label}</h4>
              <ul className={styles.list}>
                {group.options.map((option) => (
                  <SupplierSearchFilterListOption
                    key={option.value}
                    option={option}
                    handleChange={handleChange}
                    isMutli={isMulti}
                    name={name}
                    checked={filter ? filter.find((el) => el === option.value) : false}
                  />
                ))}
              </ul>
            </div>
          ))
        ) : (
          <ul className={styles.list}>
            {options?.map((option) => (
              <SupplierSearchFilterListOption
                key={option.value}
                option={option}
                handleChange={handleChange}
                isMutli={isMulti}
                name={name}
                checked={filter ? filter.find((el) => el === option.value) : false}
              />
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default SupplierSearchFilterList
